import React, { useEffect, useMemo, useRef } from 'react';

type CourseVideoPlayerProps = {
  src: string;
  onProgress?: (percent: number) => void;
};

/** 页内视频播放器：禁下载、禁右键，同一会话复用同一 src 依赖浏览器缓存 */
export const CourseVideoPlayer: React.FC<CourseVideoPlayerProps> = ({ src, onProgress }) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const stableSrc = useMemo(() => src.trim(), [src]);
  const lastReportRef = useRef(0);

  useEffect(() => {
    lastReportRef.current = 0;
  }, [stableSrc]);

  return (
    <div
      className="course-resource-player-wrap"
      onContextMenu={(e) => e.preventDefault()}
    >
      <video
        ref={videoRef}
        key={stableSrc}
        className="course-resource-video"
        src={stableSrc}
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        playsInline
        preload="auto"
        onTimeUpdate={() => {
          const el = videoRef.current;
          if (!el || !el.duration || !onProgress) return;
          const percent = Math.min(100, Math.round((el.currentTime / el.duration) * 100));
          if (percent - lastReportRef.current >= 5 || percent >= 99) {
            lastReportRef.current = percent;
            onProgress(percent);
          }
        }}
        onEnded={() => onProgress?.(100)}
      />
    </div>
  );
};
